import { motion } from "framer-motion";

export const DroneA = ({ className = "", animate = false, baseDelay = 0 }) => {
  const dropVariants = {
    hidden: { opacity: 0, y: -6 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: baseDelay + 0.7 + i * 0.12, duration: 0.4, ease: [0.16, 1, 0.3, 1] },
    }),
  };
  const drops = [
    { cx: 39, cy: 76 },
    { cx: 32, cy: 88 },
    { cx: 46, cy: 88 },
    { cx: 25, cy: 99 },
    { cx: 53, cy: 99 },
  ];
  return (
    <svg viewBox="0 0 78 104" className={className} aria-hidden="true">
      <motion.path
        d="M39 6 L6 104"
        stroke="currentColor"
        strokeWidth="15"
        strokeLinecap="square"
        fill="none"
        initial={animate ? { pathLength: 0 } : false}
        animate={animate ? { pathLength: 1 } : undefined}
        transition={{ duration: 0.7, delay: baseDelay, ease: [0.16, 1, 0.3, 1] }}
      />
      <motion.path
        d="M39 6 L72 104"
        stroke="currentColor"
        strokeWidth="15"
        strokeLinecap="square"
        fill="none"
        initial={animate ? { pathLength: 0 } : false}
        animate={animate ? { pathLength: 1 } : undefined}
        transition={{ duration: 0.7, delay: baseDelay + 0.15, ease: [0.16, 1, 0.3, 1] }}
      />
      <motion.rect
        x="17"
        y="62"
        width="44"
        height="11"
        fill="#00A651"
        initial={animate ? { scaleX: 0 } : false}
        animate={animate ? { scaleX: 1 } : undefined}
        style={{ transformOrigin: "center" }}
        transition={{ duration: 0.5, delay: baseDelay + 0.55, ease: [0.16, 1, 0.3, 1] }}
      />
      {drops.map((d, i) => (
        <motion.circle
          key={i}
          cx={d.cx}
          cy={d.cy}
          r="4"
          fill="#00A651"
          custom={i}
          variants={dropVariants}
          initial={animate ? "hidden" : false}
          animate={animate ? "visible" : undefined}
        />
      ))}
    </svg>
  );
};

const MiniDrone = () => (
  <motion.span
    className="absolute -top-[0.5em] pointer-events-none"
    initial={{ left: "50%", opacity: 0 }}
    animate={{ left: ["50%", "94%"], opacity: [0, 1, 1, 0] }}
    transition={{ delay: 1.1, duration: 1.5, times: [0, 0.12, 0.85, 1], ease: "easeInOut" }}
    aria-hidden="true"
  >
    <svg viewBox="0 0 240 150" className="h-[0.7em] w-auto">
      <path d="M120 62 L60 34 M120 62 L180 34" stroke="rgba(246,247,245,0.8)" strokeWidth="10" strokeLinecap="round" />
      <rect x="96" y="48" width="48" height="28" rx="11" fill="#1E252C" stroke="rgba(246,247,245,0.5)" strokeWidth="3" />
      <rect x="103" y="78" width="34" height="16" rx="5" fill="#00A651" />
      <ellipse cx="60" cy="34" rx="26" ry="8" fill="rgba(246,247,245,0.15)" />
      <ellipse cx="180" cy="34" rx="26" ry="8" fill="rgba(246,247,245,0.15)" />
      <circle className="spray-drop" cx="112" cy="100" r="6" fill="#00A651" />
      <circle className="spray-drop" cx="128" cy="100" r="6" fill="#00A651" style={{ animationDelay: "0.4s" }} />
    </svg>
  </motion.span>
);

const Wordmark = ({ tone = "light", className = "", animated = false }) => {
  const color = tone === "light" ? "text-[#F6F7F5]" : "text-[#151A1F]";
  const letters = [
    { l: "F" },
    { l: "U" },
    { l: "M" },
    { l: "I", green: true },
    { l: "G" },
  ];
  return (
    <span
      className={`relative font-wordmark font-bold inline-flex items-baseline leading-none ${color} ${className}`}
      aria-label="FUMIGA"
    >
      {letters.map((item, i) => (
        <span key={i} className="overflow-hidden inline-block">
          <motion.span
            className={`inline-block ${item.green ? "text-[#00A651]" : ""}`}
            initial={animated ? { y: "115%" } : false}
            animate={animated ? { y: 0 } : undefined}
            transition={{ duration: 0.8, delay: i * 0.06, ease: [0.16, 1, 0.3, 1] }}
          >
            {item.l}
          </motion.span>
        </span>
      ))}
      <DroneA
        className="inline-block h-[0.92em] w-auto self-baseline translate-y-[0.06em]"
        animate={animated}
        baseDelay={animated ? 2.3 : 0}
      />
      {animated && <MiniDrone />}
    </span>
  );
};

export default Wordmark;
